import './strategy-review.styles.scss';
import { reviewGame } from '@shared/gameReview.js';

const VERDICTS = {
    good: 'Worked',
    poor: "Didn't work",
    even: 'As expected',
};

// How each side's strategy worked in a finished game: its box score next
// to both teams' season numbers (summary/teamStats). Public information
// only (shared/gameReview.js). teamId: the manager's team, opened first.
const StrategyReview = ({ game, teamStats, seasonYear, type, minutesPerGame, teamId }) => {
    const review = reviewGame(game, { teamStats, seasonYear, type, minutesPerGame });
    if (!review?.sides.length) return null;
    const sides = [...review.sides].sort((a, b) => (b.id === teamId) - (a.id === teamId));

    return (
        <div className='strategy-review'>
            <h3>Strategy review</h3>
            {sides.map((side, i) => (
                <details key={side.id} open={teamId ? side.id === teamId : i === 0}>
                    <summary>
                        <span className='sr-team'>{side.abbr ?? side.name}</span>
                        {side.grade ?
                            <span className={`sr-grade grade-${side.grade}`}>Plan {side.grade}</span> :
                            <span className='meta'>No season numbers to compare</span>}
                        {side.score !== null &&
                            <span className='meta'>{signed(side.score)} per 100 vs. expected</span>}
                    </summary>
                    {side.expectedMargin !== null &&
                        <p className='meta sr-expected'>
                            Season numbers made {side.abbr} a{' '}
                            {Math.abs(side.expectedMargin) < 1 ? 'toss-up' :
                                `${Math.abs(side.expectedMargin).toFixed(0)}-point ${side.expectedMargin > 0 ? 'favorite' : 'underdog'}`}.
                        </p>
                    }
                    <ul>
                        {side.items.map(item => (
                            <li key={item.key}>
                                <div className='sr-head'>
                                    <b>{item.label}:</b> {item.choice}
                                    {VERDICTS[item.verdict] &&
                                        <span className={`sr-verdict ${item.verdict}`}>{VERDICTS[item.verdict]}</span>}
                                </div>
                                <div className='sr-text'>{item.text}</div>
                            </li>
                        ))}
                    </ul>
                </details>
            ))}
            {review.luck &&
                <p className='meta'>
                    {review.luck.text}
                    {review.luck.swing >= 1 && <> Free throw luck was worth about {review.luck.swing.toFixed(0)} points to {nameOf(game, review.luck.teamId)}; the grades leave it out.</>}
                </p>
            }
            <p className='meta'>
                {review.compared ?
                    'Grades compare this game with both teams\' season numbers. One game is noisy: a cold shooting night can look like a great defense, so look for what repeats over several games.' :
                    'Season numbers aren\'t available for this game (too early in the season, or a past season), so there are no grades.'}
            </p>
        </div>
    );
}

function signed(x) {
    return `${x > 0 ? '+' : x < 0 ? '−' : ''}${Math.abs(x).toFixed(1)}`;
}

function nameOf(game, id) {
    const s = game.home.id === id ? game.home : game.away;
    return s.abbr ?? s.name;
}

export default StrategyReview
